import { render, staticRenderFns } from "./Factor2c.vue?vue&type=template&id=b290b3ac&"
import script from "./Factor2c.vue?vue&type=script&lang=js&"
export * from "./Factor2c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports